jQuery(function($){
  window.onCartUpdate = function(handler){
    if (typeof handler !== 'function') return;

    var run = (ctx)=>{ if (run.t) clearTimeout(run.t); run.t = setTimeout(()=>handler(ctx||{}), 0); };

    // match /cart, /cart.js, /cart/add, /cart/add.js, /cart/update, etc.
    var isCartURL = (u)=>{
      if (!u) return false;
      try { u = (u.url || u).toString(); } catch(e){}
      return /\/cart(\/(add|change|update|clear))?(\.js)?(\?|$)/.test(u);
    };

    // jQuery $.ajax
    $(document).on('ajaxComplete', function(_, xhr, opts){
      if (!opts) return;
      if (isCartURL(opts.url) && xhr && (xhr.status >= 200 && xhr.status < 400)) {
        run({via:'jquery', url:opts.url, method:opts.type});
      }
    });

    // fetch()
    if (window.fetch && !window._cartFetchPatched){
      var _fetch = window.fetch;
      window.fetch = function(input, init){
        var url = (input && (input.url || input).toString()) || '';
        var p = _fetch.apply(this, arguments);
        if (isCartURL(url)) {
          p.then(function(res){
            if (res && res.ok) { try { res.clone().text().finally(()=>run({via:'fetch', url:url, method:(init&&init.method)||'GET'})); } catch(e){ run({via:'fetch', url:url}); } }
          });
        }
        return p;
      };
      window._cartFetchPatched = true;
    }

    // XHR
    if (window.XMLHttpRequest && !window._cartXHRPatched){
      var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function(method, url){
        this._cartURL = url; this._cartMethod = method; return XO.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function(){
        var xhr = this, done = function(){
          if (isCartURL(xhr._cartURL) && (xhr.status >= 200 && xhr.status < 400)) {
            run({via:'xhr', url:xhr._cartURL, method:xhr._cartMethod});
          }
          xhr.removeEventListener('load', done);
        };
        xhr.addEventListener('load', done);
        return XS.apply(this, arguments);
      };
      window._cartXHRPatched = true;
    }

    // Common theme events (Dawn and cousins often emit these)
    ['cart:updated','cart:update','cart:change','cart:refresh','line-item:added','cart:drawer:updated']
      .forEach(function(evt){ document.addEventListener(evt, (e)=>run({via:'event', type:evt, detail:e.detail})); });

    // Fire once so your UI can render initial state
    run({via:'init'});
  };
});


jQuery(function($){
  onCartUpdate(function(ctx){
    var selectedDate = localStorage.getItem('selectedDate');
    $('cart-delivery-date span').html(selectedDate);
    $('.date-picker-container .select_date span').html(selectedDate);
  });
});